import styled from '@emotion/styled';

const Card = styled.div`
  position: relative;
  word-wrap: break-word;
  background-color: var(--card);
  background-clip: border-box;
  border: ${(props) => (props.noBorder ? '0' : '2px solid var(--gray)')};
  border-radius: 0.5rem;
  padding: ${(props) => (props.noPadding ? '0' : '1.25rem')};
  color: var(--darkText);
  ${(props) =>
    props.end &&
    `
      grid-column-end: span 12;
  `}

  ${(props) =>
    props.clickable &&
    `
    box-shadow: 0 2px 8px var(--shadow);
    transition: box-shadow 0.3s ease;

    :hover {
      box-shadow: 0 2px 18px var(--shadow);
    }
  `}
`;

export { Card };
